import { FieldType, FormField, PROMPTS, WidthClass } from '@thehubz/client/core';
import { AgeGroup, Alignment, Channel, GroupOfPeople, Products, Type } from './arval-metadata-config';

export const arvalFields: FormField[] = [
  {
    formTypeId: '1',
    formFieldName: 'alignment',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Ausrichtung',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: Alignment,
  },
  {
    formTypeId: '2',
    formFieldName: 'ageGroup',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Altersgruppe',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: AgeGroup,
  },
  {
    formTypeId: '3',
    formFieldName: 'groupOfPeople',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Personengruppe',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: GroupOfPeople,
  },
  {
    formTypeId: '4',
    formFieldName: 'product',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Produkt',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: Products,
  },
  {
    formTypeId: '5',
    formFieldName: 'channel',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Kanal',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    formGroup: false,
    disable: false,
    editable: true,
    visible: false,
    options: Channel,
  },
  {
    formTypeId: '6',
    formFieldName: 'type',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Typ',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    formGroup: false,
    disable: false,
    editable: true,
    visible: false,
    options: Type,
  },
];
